import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VisitorBookedLayer from "../components/VisitorBookedLayer";

const VisitorBookedPage = () => {
    return (
        <MasterLayout>
            <VisitorBookedLayer />
        </MasterLayout>
    );
};

export default VisitorBookedPage;
